import { createFileRoute } from '@tanstack/react-router';

import { ArtistInteractionSearchPage } from '@/features/work-interactions/pages/ArtistInteractionSearchPage';
import { redirectUnauthenticated } from '@/shared/helper/redirectUnauthenticated';

export const Route = createFileRoute('/clubOwner/$id/profile-info/$profileId')({
  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },
  component: ArtistInteractionSearchPage
});
